/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Where should the `sellToken` be drawn from?
 */
export enum SellTokenSource {
    ERC20 = 'erc20',
    INTERNAL = 'internal',
    EXTERNAL = 'external',
}
